var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { MobileBasePage } from '../../core/base/mobile-base-page';
import { Injector, OnInit } from '@angular/core';
import { NavParams } from '@ionic/angular';
import { RouteTable } from 'src/app/core/route-table';
/**
 * Generated class for the DineIn page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
var PopupDialog = /** @class */ (function (_super) {
    __extends(PopupDialog, _super);
    function PopupDialog(injector, navParams) {
        var _this = _super.call(this, injector) || this;
        _this.injector = injector;
        _this.navParams = navParams;
        _this.ad = _this.getNavParams('ad');
        _this.store = _this.getNavParams('store');
        console.log('nav', navParams, _this.store);
        return _this;
    }
    PopupDialog.prototype.ngOnInit = function () {
        console.log('ngOnInit Popup');
    };
    PopupDialog.prototype.getImage = function () {
        return this.ad.getImage('default', 500, false);
    };
    PopupDialog.prototype.dismissClicked = function () {
        this.modalController.dismiss(null);
        // this.navController.pop({animate: false});
        console.log('dismiss?');
    };
    PopupDialog.prototype.adClicked = function () {
        console.log('ad clicked');
        this.modalController.dismiss(this.ad['links']);
        // this.pushByUrl()
        if (this.ad['links'])
            return;
        if (this.memberService.getMember()) {
            this.pushByUrl(RouteTable['MemberRewardPage']);
        }
        else {
            this.pushByUrl(RouteTable['LoginPage'], {
                store: this.store,
                fromPage: 'ByodSplashPage', logincb: function () {
                    // this.next();
                }
            });
        }
    };
    return PopupDialog;
}(MobileBasePage));
export { PopupDialog };
